import React, { useEffect, useState } from "react";
import { RxExit } from "react-icons/rx";
import ModeButton from "../ModeButton";
import { CgProfile } from "react-icons/cg";
import "./Navigation.css";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { BiLoaderCircle } from "react-icons/bi";
import { SlLogout } from "react-icons/sl";
import { DropdownMenu } from "radix-ui";
import Subscription from "../../scenes/subscription/Subscription";
import { useLocation, useParams } from "react-router-dom";
import axios from "./../../utils/axiosInstance";

const Navigation = (creditsUsed) => {
  const { credits } = creditsUsed;
  const [showDropdown, setShowDropdown] = useState(false);

  const urlObj = useLocation();

  const handleIconClick = () => {
    setShowDropdown(!showDropdown);
  };
  const [loading, setLoading] = useState(false);
  const nodes = useSelector((store) => store.flow.nodes);
  const edges = useSelector((store) => store.flow.edges);
  const handleSave = async () => {
    setLoading(true);
    const boardId = JSON.parse(localStorage.getItem("board"))._id;
    const token = localStorage.getItem("token");
    const state = {
      node: nodes,
      edge: edges,
    };
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASED_URL}/board/${boardId}`,
        { title: title, state: state }
      );
      toast.success(response.data.message);
      localStorage.setItem("board", JSON.stringify(response.data.board));
      setLoading(false);
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message);
      if (error.response.data.message === "Invalid token")
        window.location.href = "/login";
    }
  };
  const [title, SetTitle] = useState(
    JSON.parse(localStorage.getItem("board"))?.title || "Type a title..."
  );
  const updateTitle = (e) => {
    SetTitle(e.target.value);
    let board = JSON.parse(localStorage.getItem("board"));
    board = { ...board, title: e.target.value };
    localStorage.setItem("board", JSON.stringify(board));
  };

  const [profile, setProfile] = useState(null);
  useEffect(() => {
    const getProfile = async () => {
      const response = await axios.post(
        `${process.env.REACT_APP_BASED_URL}/profile`,
        { email: localStorage.getItem("emailForVerification") }
      );
      setProfile(response.data.userInfo);
    };

    getProfile();
  }, []);

  if (!profile) {
    return <div>Loading ...</div>;
  }

  return (
    <div
      className={`bg-neutral-100 dark:bg-gray-900 flex flex-row gap-3 pl-10 pr-5 items-center justify-between w-screen h-[6vh]`}
    >
      {urlObj.pathname === "/boards" ? (
        <div className="flex flex-row items-center gap-3">
          <input
            className="bg-transparent flex flex-row w-full max-w-xs h-fit gap-3 p-0.5 font-medium text-end text-xl overflow-hidden text-ellipsis resize-x text-indigo-600 rounded-lg border focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-indigo-400 transition-all duration-200"
            value={title}
            onChange={(e) => {
              updateTitle(e);
            }}
          />
          <button
            className="bg-indigo-500 hover:bg-indigo-700 bg-cover bg-center py-1 px-8 w-40 h-9 rounded-xl border-2 border-transparent cursor-pointer shadow-lg"
            onClick={handleSave}
          >
            {loading ? (
              <div className="flex items-center justify-start">
                <BiLoaderCircle
                  size={"18"}
                  className="loading-icon"
                  color="white"
                />
                <h3 className="ml-2 flex justify-start text-white font-semibold">
                  Saving
                </h3>
              </div>
            ) : (
              <div className="text-white font-semibold">Save</div>
            )}
          </button>
        </div>
      ) : (
        <div></div>
      )}
      <div className="flex flex-row gap-6 items-center">
        {profile.email !== "support@scriptwrite.ai" && (
          <Subscription profile={profile} />
        )}
        {urlObj.pathname === "/boards" && (
          <button
            className="flex items-center gap-2 text-white bg-indigo-500 hover:bg-indigo-700 bg-cover bg-center py-1 px-8 h-9 rounded-xl border-2 border-transparent cursor-pointer shadow-lg"
            onClick={() => {
              window.location.href = "/dashboard";
            }}
          >
            <div className="font-semibold">Dashboard</div>
            <RxExit size={18} />
          </button>
        )}
        {urlObj.pathname === "/boards" && <ModeButton />}
        <div className="relative">
          <DropdownMenu.Root>
            <DropdownMenu.Trigger asChild>
              <button
                className="inline-flex h-[35px] w-[35px] items-center justify-center rounded-full bg-white dark:bg-gray-700 text-gray-700 dark:text-white shadow-md hover:bg-gray-200 dark:hover:bg-gray-600 outline-none"
                onClick={handleIconClick}
              >
                <CgProfile size={25} />
              </button>
            </DropdownMenu.Trigger>

            <DropdownMenu.Portal>
              <DropdownMenu.Content
                className="absolute -right-5 min-w-[220px] rounded-md bg-white shadow-[0px_10px_38px_-10px_rgba(22,_23,_24,_0.35),_0px_10px_20px_-15px_rgba(22,_23,_24,_0.2)] will-change-[opacity,transform] data-[side=bottom]:animate-slideUpAndFade data-[side=left]:animate-slideRightAndFade data-[side=right]:animate-slideLeftAndFade data-[side=top]:animate-slideDownAndFade"
                sideOffset={5}
              >
                <DropdownMenu.Item className=" text-center text-gray-700 dark:text-gray-400 px-4 py-2">
                  <span className="text-lg font-bold">{profile.name}</span>
                </DropdownMenu.Item>
                <DropdownMenu.Separator className="h-px bg-gray-200 dark:bg-gray-700" />
                <div className="flex flex-col gap-2 px-4 py-2">
                  <DropdownMenu.Item className="text-sm text-gray-700 dark:text-gray-400">
                    Plan:{" "}
                    <span className="font-medium">{profile.plan.level}</span>
                  </DropdownMenu.Item>
                  <DropdownMenu.Item className="text-sm text-gray-700 dark:text-gray-400">
                    Starting:{" "}
                    <span className="font-medium">
                      {profile.plan?.startDate?.slice(0, 10)}
                    </span>
                  </DropdownMenu.Item>
                  <DropdownMenu.Item className="text-sm text-gray-700 dark:text-gray-400">
                    Expiring:{" "}
                    <span className="font-medium">
                      {profile.plan?.endDate?.slice(0, 10)}
                    </span>
                  </DropdownMenu.Item>
                  <DropdownMenu.Item className="text-sm text-gray-700 dark:text-gray-400">
                    Credits:{" "}
                    <span className="font-medium">
                      {Math.floor(profile.plan.creditsUsed)} /{" "}
                      {profile.plan.maxCredits}
                    </span>
                  </DropdownMenu.Item>
                </div>
                <DropdownMenu.Separator className="h-px bg-gray-200 dark:bg-gray-700" />
                <DropdownMenu.Item
                  className="flex items-center gap-2 text-sm text-red-600 hover:bg-red-100 dark:hover:bg-red-900 p-4 cursor-pointer border-none outline-none"
                  onClick={() => {
                    localStorage.clear();
                    document.location = "/";
                  }}
                >
                  <SlLogout />
                  <span>Log out</span>
                </DropdownMenu.Item>
              </DropdownMenu.Content>
            </DropdownMenu.Portal>
          </DropdownMenu.Root>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
